import React, { useEffect, useState } from "react"
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap"
import Select from "react-select"
import axios from "axios"
import { useHistory } from "react-router-dom"
import { convertPermission } from "permissionUtils"
import { Formik } from "formik"

const RD7Approval = ({
  approvalToggle,
  selectedItem,
  editing,
  setEditing,
  setAuth,
}) => {
  const history = useHistory()
  console.log("selectedItem", selectedItem)

  //************* form control ******/
  const [modal, setmodal] = useState(true)
  const toggle = () => {
    approvalToggle()
  }
  const onClose = () => {
    approvalToggle()
  }

  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )
  // console.log("userPermissions", userPermissions)

  // *********************** Validate handler ******************************** //
  const validateHandler = values => {
    let errors = {}
    if (!values.approval) errors.approval = "required"
    console.log("values", values)
    console.log("errors", errors)
    return errors
  }

  // *********************** Submit handler ******************************** //
  const submitHandler = values => {
    const formData = new FormData()

    formData.append("PerToken", localStorage.getItem("token"))
    formData.append("PerUserID", localStorage.getItem("id"))
    formData.append("PerRoleID", localStorage.getItem("userRoleID"))
    formData.append("RD7ID", selectedItem.RD7ID)
    formData.append(
      "Approval",
      values.approval === "Yes" ? true : values.approval === "No" ? false : ""
    )

    formData.append("Type", selectedItem.Status)

    values.file && formData.append("File", values.file)
    values.data && formData.append("Data", values.data)

    for (var pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1])
    }

    axios
      .post(process.env.REACT_APP_API_URL+"api/RD7/EditRD7.php", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        setEditing(!editing)
      })
      .catch(err => console.log(err))

    onClose()
  }

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-md">
      <ModalHeader>
        RD7 Approval
        <button
          type="button"
          className="btn-close position-absolute end-0 top-0 m-3"
          onClick={onClose}
        />
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={{ approval: "" }}
          validate={validateHandler}
          onSubmit={submitHandler}
        >
          {props => (
            <Form onSubmit={props.handleSubmit}>
              <FormGroup>
                <Label htmlFor="approval">RD7 Approval</Label>
                <Input
                  type="select"
                  name="approval"
                  id="approval"
                  onChange={props.handleChange}
                >
                  <option value="">RD7 Approval ...</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Input>
                {props.errors.approval ? (
                  <p className="error mx-2 d-flex justify-content-end">
                    {props.errors.approval}
                  </p>
                ) : null}
              </FormGroup>

              {props.values.approval &&
                (selectedItem.Status === "2" ||
                  selectedItem.Status === "9") && (
                  <FormGroup>
                    <Label>Recieved data and file</Label>

                    <Input
                      className="mb-3"
                      name="file"
                      type="file"
                      onChange={e =>
                        props.setFieldValue("file", e.target.files[0])
                      }
                      // accept=".pdf,.docx"
                    />

                    <Input
                      name="data"
                      id="data"
                      onChange={props.handleChange}
                      type="textarea"
                      placeholder="enter your data ..."
                    />
                  </FormGroup>
                )}

              <FormGroup className="d-flex ms-auto col-4 mt-5 justify-content-around">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  Close
                </button>
                <button type="submit" className="btn btn-danger">
                  Submit
                </button>
              </FormGroup>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  )
}

export default RD7Approval
